import { styled, Stack, CardActionArea, SxProps, Theme } from "@mui/material"
import { Icon } from "../../muiStyled/DataDisplay/Icons"
import { Typography } from "../../muiStyled/DataDisplay/typographie"

type Props = {
    title?: string
    icon?: string
    sx?: SxProps<Theme>
    onCoverClick?: () => void
}

const StyledStack = styled(Stack)({
    alignItems: "center",
    justifyContent: "center",
    gap: "3px",
    height: "100%",
    width: "100%",
})

const StyledCardActionArea = styled(CardActionArea)({
    height: "100%",
    width: "100%",
})

export function WidgetCover(props: Props) {
    const { title, icon, sx, onCoverClick } = props
    return (
        <StyledCardActionArea disableRipple sx={{ ...sx }} onClick={onCoverClick}>
            <StyledStack data-testid="widget-cover">
                <Icon name={icon} size="extralarge" />
                <Typography variant="body2">{title}</Typography>
            </StyledStack>
        </StyledCardActionArea>
    )
}
